import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  fetch() {
    Dispatcher.dispatch({
      actionType: ActionTypes.CATEGORY_STORE_FETCH,
    });
  },
  fetchById(id){
    Dispatcher.dispatch({
      actionType: ActionTypes.CATEGORY_BY_ID_STORE_FETCH,
      id: id,
    })
  }
}
